export enum GraphqlTransforms {
  TO_TYPESCRIPT = 1,
  TO_FLOW,
  TO_INTROSPECTION_JSON,
  TO_FRAGMENT_MATCHER,
  TO_SCHEMA_AST,
  TO_JAVA,
  TO_REACT_APOLLO,
  TO_APOLLO_ANGULAR,
  TO_STENCIL_APOLLO,
  TO_JAVA_RESOLVERS_SIGNATURE,
  TO_TYPESCRIPT_RESOLVERS_SIGNATURE,
  TO_FLOW_RESOLVERS_SIGNATURE,
  TO_URQL,
  TO_TYPESCRIPT_MONGODB
}
